const left_scroll = {
  methods: {
    listenerScroll(item, size = 0) {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop  //滚动条的值
      let bottom = scrollTop + window.innerHeight - $('.footer').offset().top + size
      if (bottom > - 1) {
        // console.log(bottom)
        $('.' + item).css('bottom', (bottom + 20) + 'px')
      } else {
        $('.' + item).css('bottom', (size + 20) + 'px')
      }
    }
  }
}
export { left_scroll }
